/* src/app/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import _ from 'lodash';

import { HeaderBar } from './components';
import NotificationButton from '../modules/notification/NotificationButton';
import LoginScreen from '../modules/auth/LoginScreen';
import Home from './Home';
import PageNotFound from './PageNotFound';
import ProfileMenu from '../modules/auth/ProfileMenu';
import { loadTexts } from '../config/texts';

import { smallScreen } from '../config/constants/styles';
const TEXT_KEY = 'login';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: !smallScreen,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._toggle = this._toggle.bind(this);
  }

  _toggle() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { history, user, locale } = this.props;
    const { texts } = this.state;
    const disableMenu = history.location.pathname === '/';
    const showLogOut = history.location.pathname.startsWith('/home');

    return (
      <React.Fragment>
        <HeaderBar onToggle={this._toggle} disableMenu={disableMenu} title={texts.header_title}>
          {showLogOut && <NotificationButton />}
          {showLogOut && <ProfileMenu />}
        </HeaderBar>
        <Switch>
          <Route exact path="/" component={LoginScreen} />
          <Route
            path="/home"
            render={({ match }) =>
              // TODO: is there a better way to verify that a user logged in?
              _.isEmpty(user) ? (
                <Redirect to="/" />
              ) : (
                <Home
                  match={match}
                  open={this.state.open}
                  onClose={this._toggle}
                />
              )
            }
          />
          <Route component={PageNotFound} />
        </Switch>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  logOut: PropTypes.func.isRequired,
};

const mapStateToProps = ({ auth, appState }) => {
  const {
    data: { user },
  } = auth;
  const {
    locale
  } = appState;
  return { user, locale };
};

const mapDispatchToProps = dispatch => ({
  logOut: () => dispatch({ type: 'CLEAR_AUTH' }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/app/index.js